import React, {useCallback, useRef} from 'react'
import {useSelector} from 'react-redux'
import {getFiltersLabel} from 'components/Filters/utils'
import {useFiltersForm} from 'hooks/useFiltersForm'
import {getFacetFilters} from 'modules/sapiSearch/selectors'
import {getListOfValues} from 'modules/search/selectors'

import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'
import {Icon, IconName} from '@vio/atlas/Icon'
import {Pill} from '@vio/atlas/Pill'

const filterKeys = ['themes']
const elementName = 'quickFilterThemes'
const themeIconsById: Record<number, IconName> = {
  1: 'Beach2',
  9: 'Person'
}

interface Props {
  isActive?: boolean
  themeId: string
}
export const ThemeQuickFilterPill: React.FC<Props> = ({
  isActive = false,
  themeId
}) => {
  const listOfValues = useSelector(getListOfValues)
  const {isMobile} = useDeviceLayout()
  const {themes} = useSelector(getFacetFilters)

  const buttonRef = useRef<HTMLButtonElement>(null)

  const {submitFilters, getAppliedFilters} = useFiltersForm(
    filterKeys,
    elementName
  )

  const handlePillClick = useCallback(() => {
    if (isActive) buttonRef.current?.blur()

    const activeFilters = getAppliedFilters()

    const activeThemes = activeFilters.themes || []

    const updatedFilters = {
      themes: isActive
        ? activeThemes.filter(id => themeId !== id)
        : [...activeThemes, themeId]
    }

    submitFilters(updatedFilters)
  }, [isActive, submitFilters, getAppliedFilters])

  if ((!isMobile && isActive) || !themes[themeId]?.isAvailable) return null

  return (
    <Pill
      dataId={`facilityQuickFilter:${themeId}`}
      onClick={handlePillClick}
      isSelected={isActive}
      iconStart={<Icon name={themeIconsById[themeId]} />}
      iconEnd={isActive && <Icon name={'Close'} />}
    >
      {getFiltersLabel('Theme', themeId, listOfValues)}
    </Pill>
  )
}
